export default function random() {
  return Math.random().toString(36).slice(-6);
}
